import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { SollersHome } from './types';

export function useSollersHomeData(): Page<SollersHome>['templateFields'] {
  return useCurrentPage<Page<SollersHome>>().templateFields;
}
